// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oD6aSc {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px;
  max-width: 560px;
  margin: 0 auto;
}

.cbPUZN {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.L7niDZ {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.jxShKx {
  font-size: 14px;
  color: var(--color-text-secondary, #4a4a4a);
  margin: 0;
}

.TyvAh5 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.MCSS6O {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.sBsJMP {
  display: block;
  font-size: 14px;
  margin: 0;
}

.Dgf3L3 {
  color: var(--color-success, #0f7b32);
}

.xwNsHp {
  color: var(--color-error, #c0392b);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/components/DeveloperSettings/DeveloperSettings.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 32px;\n  max-width: 560px;\n  margin: 0 auto;\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.title {\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.description {\n  font-size: 14px;\n  color: var(--color-text-secondary, #4a4a4a);\n  margin: 0;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.feedback {\n  display: block;\n  font-size: 14px;\n  margin: 0;\n}\n\n.feedbackSuccess {\n  color: var(--color-success, #0f7b32);\n}\n\n.feedbackError {\n  color: var(--color-error, #c0392b);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `oD6aSc`,
	"header": `cbPUZN`,
	"title": `L7niDZ`,
	"description": `jxShKx`,
	"form": `TyvAh5`,
	"actions": `MCSS6O`,
	"feedback": `sBsJMP`,
	"feedbackSuccess": `Dgf3L3`,
	"feedbackError": `xwNsHp`
};
module.exports = ___CSS_LOADER_EXPORT___;
